<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="8">
          <b-form @submit.prevent="editAccount">
          <b-row>
            <b-col sm="12">
              <b-form-group label="Email">
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="admin.email"
                  placeholder="Enter email address"
                  name="email"
                  :class="{'has-error': errors.has('email')}"
                ></b-form-input>
                <span class="red">{{ errors.first('email') }}</span>
              </b-form-group>

              <b-form-group label="Name">
                <b-row>
                  <b-col sm="6">
                    <b-form-input
                      type="text"
                      v-validate="'required'"
                      v-model="admin.first_name"
                      placeholder="Enter first name"
                      name="first_name"
                      :class="{'has-error': errors.has('first_name')}"
                    ></b-form-input>
                    <span class="red">{{ errors.first('first_name') }}</span>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      type="text"
                      v-validate="'required'"
                      v-model="admin.last_name"
                      placeholder="Enter last name"
                      name="last_name"
                      :class="{'has-error': errors.has('last_name')}"
                    ></b-form-input>
                    <span class="red">{{ errors.first('last_name') }}</span>
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group>
                <b-button type="submit" name="submit" variant="primary">Save changes</b-button>
              </b-form-group>
            </b-col>
          </b-row>
          </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import getAdmin from './../../mixins/getAdmin'

export default {
  name: 'Account',
  mixins: [
    getAdmin
  ],
  data: function () {
    return {
      admin: {}
    }
  },
  methods: {
    /**
     * Sends a put request to the admins controller in the backend API with new account information to update the authenticated admin.
     */
    editAccount: function () {
      let self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.put(`${process.env.VUE_APP_API_URL}api/admins/${localStorage.getItem('user-id')}`, {
            email: self.admin.email,
            first_name: self.admin.first_name,
            last_name: self.admin.last_name,
            level: self.admin.level
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': localStorage.getItem('user-token')
            }
          })
            .then(function (response) {
              self.$notify({
                group: 'custom-template',
                title: `Account successfully updated!`,
                text: `<p>&nbsp;</p>`,
                type: 'success'
              })
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      }).catch(() => {
        console.log(this.errors.all())
      })
    }
  },
  mounted () {
    this.getAdmin()
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
